import React from "react";
import { styled } from "../stitches.config";

export default function SkipNav() {
  return (
    <>
      <VisibleOnFocus
        href="#main"
        className="visually-hidden"
        onClick={(e) => {
          e.preventDefault();
          // For some reason anchor links not working, use JS
          const main = document.getElementById("#main");
          if (main) {
            main.tabIndex = -1;
            main.focus();
          }
        }}
      >
        Skip to main canvas
      </VisibleOnFocus>
    </>
  );
}

const VisibleOnFocus = styled("a", {
  "&:focus": {
    top: 0,
    left: 0,
    padding: "$2",
    zIndex: "1",
    background: "$menuBeige",
  },
});
